export enum MutationStatus {
  open = 'open',
  accepted = 'accepted',
  declined = 'declined',
}
